import clevertap from "clevertap-web-sdk";
import { memo, useContext, useEffect, useRef, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";
import { Toggle } from "react-toggle-component";

// assets
// import { SvgClubInfinitum as ClubInfinitum } from "assets/icons/js/SvgClubInfinitum";
import { ReactComponent as Filter } from "assets/filter.svg";
import { SvgSignatureHomes as SignatureHomes } from "assets/icons/js/SvgSignatureHomes";
import { SvgSortBy as SortBy } from "assets/icons/js/SvgSortBy";

// components
import { NewCategoryBudgetFilters } from "./NewCategoryBudgetFilters";
import NewCategoryAmenitiesFilters from "./NewCategoryAmenitiesFilters";
import NewCategoryMoreFilters from "./NewCategoriesMoreFilters";

//customData
import { filtersAmenityTypes } from "lib/filtersAmenityTypes";
import { filtersMore } from "lib/filtersMore";

// context
import { SearchPageDataInterface } from "context/SearchPageData";

// styles
import "./style.scss";
import { SvgDownArrow } from "assets/icons/js/SvgDownArrow";
import { SvgClubinfintum } from "assets/icons/js/SvgClubinfintum";
import { Tooltip } from "components/Tooltip";
import { SvgSearchNextSaffronLogo } from "assets/icons/js/SvgSearchNextSaffronLogo";
import { SvgNextLogo } from "assets/icons/js/SvgNextLogo";
import { SvgMariott } from "assets/icons/js/SvgMariott";
import { ReactComponent as NextFilter } from "assets/icons/NextFilter.svg";
const FiltersAndSort = () => {
	const {
		showAmenities,
		setShowAmenities,
		showMore,
		setShowMore,
		setSelectBudget,
		selectBudget,
		moreFilter,
		query,
	} = useContext(SearchPageDataInterface);

	const [searchParams, setSearchParams] = useSearchParams();
	const [showBudget, setShowBudget] = useState(true);
	const [showRecommend, setShowRecommend] = useState(true);

	// amenities
	const Amenities = (
		<>
			<div className="type__filter top__filter__container box__container">
				<div
					className="filters__hometype__capsule"
					onClick={() => setShowAmenities(!showAmenities)}
				>
					<span>Top Filters</span>
					<SvgDownArrow
						color="#333333"
						style={{ transform: showAmenities ? "" : "rotate(180deg)" }}
					/>
				</div>
				{showAmenities && (
					<NewCategoryAmenitiesFilters amenityTypes={filtersAmenityTypes} />
				)}
			</div>
		</>
	);

	// signature and ClubInfinitum
	const Signature = (
		<div className="signature__filter__container box__container">
			<span
				className="dropdown"
				onClick={() => setShowRecommend((prev) => !prev)}
			>
				<span>We Recommend</span>
				<SvgDownArrow
					color="#333333"
					style={{ transform: showRecommend ? "" : "rotate(180deg)" }}
				/>
			</span>
			{showRecommend && (
				<>
					<div
						className={
							searchParams.get("x-series") !== "true"
								? "filters__hometype__capsule"
								: "filters__hometype__capsule "
						}
					>
						<span>
							<img
								src="https://ik.imagekit.io/5tgxhsqev/saffronstays-media/xseries.svg"
								alt=""
							/>
							X-Series
							<Tooltip
								text={
									"Larger than Life estates with X factor. For life’s special celebrations"
								}
								background={"#666666"}
							/>
						</span>
						<input
							id="filter"
							type="checkbox"
							checked={
								searchParams.get("x-series") === "" ||
								searchParams.get("x-series") === "false" ||
								searchParams.get("x-series") === null
									? false
									: true
							}
							value={searchParams.get("x-series") === "false" ? false : true}
							onChange={() => {
								if (
									searchParams.get("x-series") === null ||
									searchParams.get("x-series") === "false" ||
									searchParams.get("x-series") === ""
								) {
									searchParams.set("x-series", "true");
									setSearchParams(searchParams);
								} else if (
									searchParams.get("x-series") !== null &&
									searchParams.get("x-series") === "true"
								) {
									searchParams.set("x-series", "false");
									setSearchParams(searchParams);
								}
								clevertap.event.push("search_filter", {
									search_location: window.location.pathname
										?.split("/")[2]
										?.split("-")[2],
									type_of_filter: "x-series Home",
									timestamp: new Date(),
									collectionImage:
										"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:q-30/image/upload/collections/u7lawuhqhecivq2rsoql",
									collection:
										"https://saffronstays.com/collection/Signature-villas-and-estates",
									url: window.location.pathname + window.location.search,
								});
							}}
						/>
					</div>

					<div
						className={
							searchParams.get("signature") !== "true"
								? "filters__hometype__capsule"
								: "filters__hometype__capsule "
						}
					>
						<span>
							<SignatureHomes width={25} height={25} />
							Signature
							<Tooltip
								text={
									"Top of the Line, Luxury Villas in stunning locations.  Suited best for special occasions and celebrations."
								}
								background={"#666666"}
							/>
						</span>
						<input
							id="filter"
							type="checkbox"
							checked={
								searchParams.get("signature") === "" ||
								searchParams.get("signature") === "false" ||
								searchParams.get("signature") === null
									? false
									: true
							}
							value={searchParams.get("signature") === "false" ? false : true}
							onChange={() => {
								if (
									searchParams.get("signature") === null ||
									searchParams.get("signature") === "false" ||
									searchParams.get("signature") === ""
								) {
									searchParams.set("signature", "true");
									setSearchParams(searchParams);
								} else if (
									searchParams.get("signature") !== null &&
									searchParams.get("signature") === "true"
								) {
									searchParams.set("signature", "false");
									setSearchParams(searchParams);
								}
								clevertap.event.push("search_filter", {
									search_location: window.location.pathname
										?.split("/")[2]
										?.split("-")[2],
									type_of_filter: "Signature Home",
									timestamp: new Date(),
									collectionImage:
										"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:q-30/image/upload/collections/u7lawuhqhecivq2rsoql",
									collection:
										"https://saffronstays.com/collection/Signature-villas-and-estates",
									url: window.location.pathname + window.location.search,
								});
							}}
						/>
					</div>

					<div
						className={
							searchParams.get("next") !== "true"
								? "filters__hometype__capsule"
								: "filters__hometype__capsule filters-type-capsule-active"
						}
					>
						<span>
							<SvgMariott />
							Marriott Bonvoy
						</span>
						<input
							id="filter"
							type="checkbox"
							checked={
								searchParams.get("next") === "" ||
								searchParams.get("next") === "false" ||
								searchParams.get("next") === null
									? false
									: true
							}
							value={searchParams.get("next") === "false" ? false : true}
							onChange={() => {
								if (
									searchParams.get("next") === null ||
									searchParams.get("next") === "false" ||
									searchParams.get("next") === ""
								) {
									searchParams.set("next", "true");
									setSearchParams(searchParams);
								} else if (
									searchParams.get("next") !== null &&
									searchParams.get("next") === "true"
								) {
									searchParams.set("next", "false");
									setSearchParams(searchParams);
								}
								clevertap.event.push("search_filter", {
									type_of_filter: "next Home",
									timestamp: new Date(),
									url: window.location.pathname + window.location.search,
									search_location: window.location.pathname
										?.split("/")[2]
										?.split("-")[2],
								});
							}}
						/>
					</div>

					<div
						className={
							searchParams.get("is_next") !== "true"
								? "filters__hometype__capsule"
								: "filters__hometype__capsule filters-type-capsule-active"
						}
					>
						<span>
							<NextFilter width={"25px"} height={"25px"} />
							Next
							<Tooltip
								text={"Young, Fresh & Pocket Friendly Homes"}
								background={"#666666"}
							/>
						</span>
						<input
							id="filter"
							type="checkbox"
							checked={
								searchParams.get("is_next") === "" ||
								searchParams.get("is_next") === "false" ||
								searchParams.get("is_next") === null
									? false
									: true
							}
							value={searchParams.get("is_next") === "false" ? false : true}
							onChange={() => {
								if (
									searchParams.get("is_next") === null ||
									searchParams.get("is_next") === "false" ||
									searchParams.get("is_next") === ""
								) {
									searchParams.set("is_next", "true");
									setSearchParams(searchParams);
								} else if (
									searchParams.get("is_next") !== null &&
									searchParams.get("is_next") === "true"
								) {
									searchParams.set("is_next", "false");
									setSearchParams(searchParams);
								}
								clevertap.event.push("search_filter", {
									type_of_filter: "is_next Home",
									search_location: window.location.pathname
										?.split("/")[2]
										?.split("-")[2],
									timestamp: new Date(),
									url: window.location.pathname + window.location.search,
								});
							}}
						/>
					</div>
					<div
						className={
							searchParams.get("club") !== "true"
								? "filters__hometype__capsule"
								: "filters__hometype__capsule filters-type-capsule-active"
						}
					>
						<span>
							<SvgClubinfintum />
							Club Infinitum
							<Tooltip
								text={"Homes where you can redeem your reward points"}
								background={"#666666"}
							/>
						</span>
						<input
							id="filter"
							type="checkbox"
							checked={
								searchParams.get("club") === "" ||
								searchParams.get("club") === "false" ||
								searchParams.get("club") === null
									? false
									: true
							}
							value={searchParams.get("club") === "false" ? false : true}
							onChange={() => {
								if (
									searchParams.get("club") === null ||
									searchParams.get("club") === "false" ||
									searchParams.get("club") === ""
								) {
									searchParams.set("club", "true");
									setSearchParams(searchParams);
								} else if (
									searchParams.get("club") !== null &&
									searchParams.get("club") === "true"
								) {
									searchParams.set("club", "false");
									setSearchParams(searchParams);
								}
								clevertap.event.push("search_filter", {
									type_of_filter: "club Home",
									search_location: window.location.pathname
										?.split("/")[2]
										?.split("-")[2],
									timestamp: new Date(),
									url: window.location.pathname + window.location.search,
								});
							}}
						/>
					</div>
				</>
			)}
		</div>
	);

	const More = (
		<>
			<div className="type__filter box__container">
				<div
					className={`filters__hometype__capsule ${
						moreFilter?.length > 0 ? "filters-type-capsule-active" : ""
					} `}
					onClick={() => setShowMore(!showMore)}
				>
					<span>Other filters</span>
					<SvgDownArrow
						color="#333333"
						style={{ transform: showMore ? "" : "rotate(180deg)" }}
					/>
				</div>
				{showMore && <NewCategoryMoreFilters moreFilters={filtersMore} />}
			</div>
		</>
	);

	const BudgetFilter = (
		<>
			<div className="type__filter budget__filter__container box__container">
				<div
					className={`filters__hometype__capsule`}
					onClick={() => {
						setShowBudget((prev) => !prev);
						clevertap.event.push("search_filter", {
							type_of_filter: "Budget Fillter",
							timestamp: new Date(),
							collectionImage:
								"https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:q-35/image/upload/collections/u65q3uqb4ds8pqi3weon",
							collection: "https://saffronstays.com/collection/budget-villas",
							url: window.location.pathname + window.location.search,
							search_location: window.location.pathname
								?.split("/")[2]
								?.split("-")[2],
						});
					}}
				>
					<span>
						Price
						<strong>(per night)</strong>
					</span>
					<SvgDownArrow
						color="#333333"
						style={{ transform: showBudget ? "" : "rotate(180deg)" }}
					/>
				</div>
				{showBudget && (
					<NewCategoryBudgetFilters
						setSelectBudget={setSelectBudget}
						selectBudget={selectBudget}
						query={query}
						setShowBudget={setShowBudget}
					/>
				)}
			</div>
		</>
	);

	return (
		<div className="filters__and__sort__wrapper">
			<div className="filters__list">
				<span className="filters__title">{Signature}</span>
				{Amenities}
				{Event}
				{/* {Available} */}
				{BudgetFilter}
				{More}
				{/* <div className="fillters__column">
					<Toggle
						name="toggle-1"
						leftBackgroundColor="#ffffff"
						rightBackgroundColor="#ffffff"
						backgroundColorDisabled="#eee"
						rightBorderColor="#2368a2"
						rightKnobColor="#2368a2"
						checked={
							searchParams.get("unavail") === "" ||
							searchParams.get("unavail") === "false" ||
							searchParams.get("unavail") === null
								? true
								: false
						}
						onToggle={(e) => {
							if (
								searchParams.get("unavail") === "" ||
								searchParams.get("unavail") === null ||
								searchParams.get("unavail") === "false"
							) {
								searchParams.set("unavail", "true");
								setSearchParams(searchParams, { replace: true });
							} else if (
								searchParams.get("unavail") !== null &&
								searchParams.get("unavail") === "true"
							) {
								searchParams.set("unavail", "false");
								setSearchParams(searchParams, { replace: true });
							}
							clevertap.event.push("search_filter", {
								type_of_filter: "Unavailable Home",
								timestamp: new Date(),
							});
						}}
					/>
					<p>Show Only if Available</p>
				</div> */}
			</div>
		</div>
	);
};

export default memo(FiltersAndSort);
